import { TargetedPetitionList } from './TargetedPetitionList';

export function TargetedPetitionListWrapper() {
	return (
		<div className="mb-8">
			<TargetedPetitionList />
		</div>
	);
}
